import InfoDialog from './infoDialog';
export default InfoDialog;